'use client';

import { DynamicPage, FormIdentifier } from '@shesha-io/reactjs';
import React, { FC } from 'react';

interface IProps {
  searchParams: NodeJS.Dict<string | string[]>;
}

const Page: FC<IProps> = (props) => {
  const { searchParams } = props;

  const formId: FormIdentifier = {
    module: 'Boxfusion.Dispatcher',
    name: 'incidents-dashboard',
  };

  return <DynamicPage {...searchParams} formId={formId} />;
};

export default Page;
